<template>
  <div class="is-covering">
    <Splitpanes v-if="editLayoutHorizontal" horizontal class="default-theme">
      <Pane
        id="imageHorizontal"
      >
        <slot name="image"></slot>
      </Pane>
      <Pane id="contentHorizontal">
        <slot name="content"></slot>
      </Pane>
    </Splitpanes>
    <Splitpanes v-else class="default-theme">
      <Pane id="imageVertical" style="">
        <slot name="image"></slot>
      </Pane>
      <Pane id="contentVertical" style="">
        <slot name="content"></slot>
      </Pane>
    </Splitpanes>
  </div>
</template>

<script>
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";

import { mapState } from "vuex";

export default {
  components: { Splitpanes, Pane },
  computed: {
    ...mapState("content", ["editLayoutHorizontal"]),
  },
  props: {
    name: {
      type: String,
      validator: (value) => {
        return ["both", "image", "content", "edit"].includes(value);
      },
    },
  },
};
</script>
